import React from 'react'
import { ExpandMore } from '@material-ui/icons'
import { CoreConfigParent } from '../../../../interfaces/examiner/CoreConfig'
import { ConfigurationsClasses } from './styles'

interface Props {
    parents: CoreConfigParent[]
    activeSectionId: string
    expandedParents: Record<string, boolean>
    onToggleParent: (parentId: string) => void
    onSelectSection: (sectionId: string, parentId: string) => void
    classes: ConfigurationsClasses
}

export default function ConfigSidebar({
    parents,
    activeSectionId,
    expandedParents,
    onToggleParent,
    onSelectSection,
    classes,
}: Props) {
    return (
        <nav className={classes.sidebar}>
            {parents.map((parent) => {
                const isParentExpanded = !!expandedParents[parent.id]
                const hasActiveSection = parent.sections.some(
                    (section) => section.id === activeSectionId
                )
                return (
                    <div key={parent.id}>
                        <button
                            type="button"
                            className={`${classes.parentButton} ${
                                hasActiveSection ? classes.parentButtonActive : ''
                            }`}
                            onClick={() => onToggleParent(parent.id)}
                            aria-expanded={isParentExpanded}
                        >
                            <span>{parent.title}</span>
                            <ExpandMore
                                className={`${classes.parentChevron} ${
                                    isParentExpanded ? classes.parentChevronExpanded : ''
                                }`}
                            />
                        </button>
                        {isParentExpanded && (
                            <div className={classes.sectionList}>
                                {parent.sections.map((section) => (
                                    <button
                                        key={section.id}
                                        type="button"
                                        className={`${classes.sectionButton} ${
                                            section.id === activeSectionId
                                                ? classes.sectionButtonActive
                                                : ''
                                        }`}
                                        onClick={() =>
                                            onSelectSection(section.id, parent.id)
                                        }
                                    >
                                        {section.title}
                                    </button>
                                ))}
                            </div>
                        )}
                    </div>
                )
            })}
        </nav>
    )
}
